import { Box, SimpleGrid, Text, Flex, Stack } from "@mantine/core";
import SidesComponent from "./SidesComponent";
import SidedBottomBar from "./SidedBottomBar";
import BottomBar from "./BottomBar";

const PollComponent = ({
  thesis,
  isQuestion,
  brandAccount,
  hasSideImage,
  sides,
}) => (
  <>
    <SimpleGrid cols={1} style={{ height: "100%", gap: "0px" }}>
      <Box className="poll-component-box">
        <Text className="poll-thesis cursor-pointer">{thesis}</Text>

        {!isQuestion && (
          <Flex
            style={{ gap: "6px", padding: "0px 20px 0px 20px" }}
            align="center"
          >
            {brandAccount?.avatarObject?.thumb?.location && (
              <img
                onError={(e) => {
                  const target = e.target;
                  target.onerror = null;
                  target.src = `${
                    process.env.VITE_S3_BUCKET_BASE_URL
                  }/defaultSideImage.svg`;
                }}
                src={brandAccount.avatarObject.thumb.location}
                alt={brandAccount.name}
                style={{
                  borderRadius: "50%",
                  width: "15px",
                  height: "15px",
                  border: "1px solid black",
                }}
              />
            )}
            <Text c="#4F4F4F" fw={400} style={{ fontSize: "12px" }}>
              {brandAccount?.name}
            </Text>
          </Flex>
        )}

        {!isQuestion ? (
          <SidesComponent hasSideImage={hasSideImage} sides={sides} />
        ) : (
          <Stack style={{ margin: "8px 20px" }} gap={6}>
            <ul className="sides">
              {sides.map((side) => (
                <li key={side.id} className="cursor-pointer poll-side-open-container">
                  <span className="a">{side.text}</span>
                </li>
              ))}
            </ul>
          </Stack>
        )}

        {!isQuestion && (
          <>
            <BottomBar />
            <SidedBottomBar />
          </>
        )}
      </Box>
    </SimpleGrid>
  </>
);

export default PollComponent;
